module.exports = __webpack_public_path__ + "img/logo-kakao-vx-foot@3x.233f840d.png";